import React from "react";


const Cookie = () => {
  return (

    <section className="terms-area pt-130 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h2 className="text-center title mb-4">Terms and Conditions</h2>
            <p className="merriweather-sans text-center mb-4">Welcome to <b className="text-white">DIAG</b> (accessible at https://diagnostica.app/) operated by <b className="text-white"> Diagnostica Solutions Pty Ltd </b> (“we”, “us”, “our”). By accessing or using our website, services, or participating in the DIAG Token ecosystem, you agree to the following Terms and Conditions. Please read them carefully.
            </p>
          </div>
        </div>

        <div className="terms-content">
          <div className="pt-4">
            <h5 className="fw-title">1. Acceptance of Terms</h5>
            <p className="merriweather-sans">By using this website, you confirm that you are at least 18 years old and legally eligible to participate in the DIAG Token sale or use the Diagnostica App. If you do not agree with these terms, please do not use this site or related services.
            </p>
          </div>
          <div className="py-2">
            <h5 className="fw-title">2. About DIAG Token</h5>
            <p className="merriweather-sans">DIAG is a utility token used within the Diagnostica ecosystem to access healthcare services, incentivize users, enable staking, and participate in governance. It does not represent equity, securities, or ownership rights in Diagnostica Solutions Pty Ltd.</p>
          </div>

          <div>
            <h5 className="fw-title">3. No Financial or Medical Advice</h5>
            <p className="merriweather-sans">The information on this website does not constitute financial, investment, legal, or medical advice. All users are strongly encouraged to conduct their own due diligence and consult with professionals before making any decisions related to token purchases or healthcare actions.</p>
          </div>

          <div className="py-2">
            <h5 className="fw-title">4. Token Sale Participation</h5>
            <p className="merriweather-sans mb-0">Purchasing DIAG Tokens may involve risks including market volatility and regulatory changes. You agree that:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">You are not a citizen or resident of any jurisdiction where participation in ICOs is prohibited.</li>
              <li className="list-circle">You will comply with all applicable laws, including anti-money laundering (AML) and Know Your Customer (KYC) regulations.</li>
              <li className="list-circle">Tokens purchased are non-refundable and do not entitle you to any guaranteed returns or future profits.</li>
            </ul>
          </div>
          <div className="py-2">
            <h5 className="fw-title">5. User Conduct</h5>
            <p className="merriweather-sans mb-0">You agree to use the website and services only for lawful purposes. Prohibited conduct includes:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Attempting to gain unauthorized access to the website or app</li>
              <li className="list-circle">Distributing malware or other harmful code</li>
              <li className="list-circle">Engaging in fraud, impersonation, or deceptive activities</li>
            </ul>
          </div>
          <div className="py-2">
            <h5 className="fw-title">6. Intellectual Property</h5>
            <p className="merriweather-sans">All content on this website, including trademarks, graphics, text, and software, is the property of Diagnostica Solutions Pty Ltd or its partners. You may not use, copy, or reproduce this content without prior written consent.
            </p>
          </div>
          <div>
            <h5 className="fw-title">7. Privacy and Data Protection</h5>
            <p className="merriweather-sans">We are committed to protecting your personal data in compliance with <b className="text-white">GDPR</b> and <b className="text-white">HIPAA</b> standards. By using our platform, you consent to the collection and use of your information as outlined in our Privacy Policy.
            </p>
          </div>
          <div className="py-2">
            <h5 className="fw-title">8. Third-Party Links</h5>
            <p className="merriweather-sans">Our website may contain links to third-party services, including wearable devices, healthcare providers, or crypto exchanges. We are not responsible for the content or practices of these external websites.
            </p>
          </div>
          <div>
            <h5 className="fw-title">9. Limitation of Liability</h5>
            <p className="merriweather-sans">Diagnostica Solutions Pty Ltd shall not be held liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use the website, app, or DIAG Tokens. Use is at your own risk.</p>
          </div>
          <div className="py-2">
            <h5 className="fw-title">10. Indemnification</h5>
            <p className="merriweather-sans">You agree to indemnify and hold harmless Diagnostica Solutions Pty Ltd and its affiliates from any claims, damages, losses, or liabilities resulting from your violation of these Terms or misuse of the platform.</p>
          </div>
          <div>
            <h5 className="fw-title">11. Changes to Terms</h5>
            <p className="merriweather-sans">We reserve the right to update or modify these Terms at any time. Continued use of the site or platform after such changes constitutes your acceptance of the updated Terms.</p>
          </div>
          <div className="py-2">
            <h5 className="fw-title">12. Governing Law</h5>
            <p className="merriweather-sans">These Terms shall be governed by and construed in accordance with the laws of <b className="text-white"> New South Wales, Australia,</b> without regard to conflict of law principles.</p>
          </div>
          <div>
            <h5 className="fw-title">13. Contact Us</h5>
            <p className="merriweather-sans">If you have any questions about these Terms, please contact us at :
              <a href="mailto:diag@diagnostica.app"> diag@diagnostica.app</a></p>
          </div>
        </div>
      </div>
    </section>



  );
};

export default Cookie;
